// extracted by mini-css-extract-plugin
module.exports = {"main":"BenefitsSection_main__zmajp"};